import React from "react";
import { Link } from 'react-router-dom';

function NextPeriod({ url }){
    return (
        <Link to={url} className="next-previous-period" style={{marginLeft: '15px'}}>{"Next Period >>"}</Link>
    );
}

export default NextPeriod;